import DefaultContext from 'flexbiz-core/components/auth/Context';
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { AiFillCopy, AiFillDelete, AiFillEdit, AiFillFileAdd, AiFillPrinter } from 'react-icons/ai';
import { BiExport, BiImport } from 'react-icons/bi';
import { TfiReload } from 'react-icons/tfi';
import { useCore } from '../../../../hooks';
import VButton from '../../VComponent/VButton';
import LayoutContainer from '../../components/LayoutContainer';
import TableManager from '../../components/tableManager/TableManager';
import withContainer from '../../withContainer';
import { formatNumberWithSpaces } from '../Utils';
import NotiDialog from '../components/NotiDialog';
import VoucherFilter from '../components/VoucherFilter';
import AddVoucherDialog from './Dialog/AddVoucherDialog';
import CopyVoucherDialog from './Dialog/CopyVoucherDialog';
import EditVoucherDialog from './Dialog/EditVoucherDialog';
import VoucherDetail from './VoucherDetailPN/VoucherDetail';
export const VoucherContext = createContext();

const columns = [
	{
		Header: 'Ngày chứng từ',
		accessor: 'ngay_ct',
		width: 150,
		minWidth: 100,
		maxWidth: 400,
		Filter: false,
	},
	{
		Header: 'Mã CT',
		accessor: 'ma_ct',
		width: 150,
		minWidth: 100,
		maxWidth: 400,
	},
	{
		Header: 'Số CT',
		accessor: 'so_ct',
		width: 150,
		minWidth: 100,
		maxWidth: 400,
		Filter: false,
	},
	{
		Header: 'TK có',
		accessor: 'tk_co',
		width: 150,
		minWidth: 100,
		maxWidth: 400,
		Filter: false,
	},
	{
		Header: 'Nhà cung cấp',
		accessor: 'ten_kh',
		width: 150,
		minWidth: 100,
		maxWidth: 400,
		Filter: false,
	},
	{
		Header: 'SL',
		accessor: 't_sl',
		width: 150,
		minWidth: 100,
		maxWidth: 400,
		type: 'number',
		Filter: false,
	},
	{
		Header: 'Tiền hàng',
		accessor: 't_tien_hang_nt',
		width: 150,
		minWidth: 100,
		maxWidth: 400,
		type: 'number',
		Filter: false,
	},
	{
		Header: 'Tiền CK',
		accessor: 't_ck_nt',
		width: 150,
		minWidth: 100,
		maxWidth: 400,
		type: 'number',
		Filter: false,
	},
	{
		Header: 'Tiền phí',
		accessor: 't_cp_nt',
		width: 150,
		minWidth: 100,
		maxWidth: 400,
		type: 'number',
		Filter: false,
	},
	{
		Header: 'Tiền nhập',
		accessor: 't_tien_nhap_nt',
		width: 150,
		minWidth: 100,
		maxWidth: 400,
		type: 'number',
		Filter: false,
	},
	{
		Header: 'VAT',
		accessor: 't_thue_vao_nt',
		width: 150,
		minWidth: 100,
		maxWidth: 400,
		type: 'number',
		Filter: false,
	},
	{
		Header: 'Tổng t.toán',
		accessor: 't_tt_nt',
		width: 150,
		minWidth: 100,
		maxWidth: 400,
		type: 'number',
		Filter: false,
	},
];

function VoucherPN1({ title, api }) {
	const core = useCore();
	const [openAdd, setOpenAdd] = useState(false);
	const [openEdit, setOpenEdit] = useState(false);
	const [openCopy, setOpenCopy] = useState(false);
	const [openDelete, setOpenDelete] = useState(false);
	const MenuTabTable = [
		{
			id: 1,
			name: 'Mới',
			icon: <AiFillFileAdd />,
			handle: () => {
				setOpenAdd(true);
			},
		},
		{
			id: 2,
			name: 'Sửa',
			icon: <AiFillEdit />,
			handle: () => {
				setOpenEdit(true);
			},
		},
		{
			id: 3,
			name: 'Xoá',
			icon: <AiFillDelete />,
			handle: () => {
				handleDeleteVoucher();
			},
		},
		{
			id: 4,
			name: 'Chép dữ liệu',
			icon: <AiFillCopy />,
			handle: () => {
				setOpenCopy(true);
			},
		},
		// {
		// 	id: 5,
		// 	name: "Tìm",
		// 	icon: <RiFileSearchFill />,
		// },
		// {
		// 	id: 6,
		// 	name: 'Xem',
		// 	icon: <AiOutlineFundView />,
		// 	handle: () => {
		// 		setOpenEdit(true);
		// 	},
		// },
		{
			id: 7,
			name: 'In',
			icon: <AiFillPrinter />,
			handle: () => {
				alert('Tính năng đang phát triển');
			},
		},
		{
			id: 8,
			name: 'Nhập',
			icon: <BiImport />,
			handle: () => {
				alert('Tính năng đang phát triển');
			},
		},
		{
			id: 9,
			name: 'Xuất',
			icon: <BiExport />,
			handle: () => {
				alert('Tính năng đang phát triển');
			},
		},
		// {
		// 	id: 10,
		// 	name: 'Làm mới',
		// 	icon: <MdRefresh />,
		// },
	];
	const [totalRows, setTotalRows] = useState();
	const [params, setParams] = useState({
		limit: 20,
		page: 1,
		t: 1,
	});
	const [dataVoucherPN1, setDataVoucherPN1] = useState([]);
	const [dataVoucherDetail, setDataVoucherDetail] = useState('');
	const [dataDoubleClick, setDataDoubleClick] = useState('');
	const [dataVoucherSelect, setDataVoucherSelect] = useState('');
	const context = useContext(DefaultContext);

	const skipResetRef = React.useRef(false);
	const updateMyData = (rowIndex, columnId, value) => {
		skipResetRef.current = true;
		setDataVoucherPN1((old) =>
			old.map((row, index) => {
				if (index === rowIndex) {
					return {
						...row,
						[columnId]: value,
					};
				}
				return row;
			})
		);
	};

	const handleCloseAdd = () => {
		getDataVoucherPN();
		setOpenAdd(false);
	};

	const handleCloseEdit = () => {
		setOpenEdit(false);
		setDataDoubleClick('');
	};

	// xử lý trả ra data khi click vào nút copy
	const handleDataCopyVoucher = (dataNew) => {
		const dataCopy = dataNew.map((item) => {
			// xoá so_hd trong vatvaos
			const vatvaosNews = item.vatvaos.map((item) => {
				return {
					...item,
					so_hd: '',
					ngay_hd: new Date().toISOString(),
				};
			});
			return {
				...item,
				so_ct: '',
				_id: undefined,
				vatvaos: vatvaosNews,
				ngay_ct: new Date(),
			};
		});
		return dataCopy;
	};

	const handleCloseCopy = () => {
		getDataVoucherPN();
		setOpenCopy(false);
	};

	const handleCloseDelete = () => {
		setOpenDelete(false);
	};

	const getDataVoucherDetail = (data) => {
		setDataVoucherDetail(data);
	};

	const handleSelectRow = (data) => {
		// console.log("data select", data);
		handleCloseEdit();
		setDataVoucherSelect(data);
	};

	// get data PN11 voucher
	const getDataVoucherPN = useCallback(async () => {
		core.setProgressStatus(true);

		try {
			const [data, count] = await Promise.all([
				core.asyncGetList(core.token, api, {
					...params,
				}),
				core.asyncGetList(core.token, api, {
					count: 1,
					q: params.q,
				}),
			]);

			// set total pages
			const totalItem = count.rows_number;
			setDataVoucherPN1(data);
			setTotalRows(totalItem);
			setDataVoucherDetail(data[0] || '');
			// console.log("data", data);
		} catch (error) {
			console.log('getDataProduct error', error);
		} finally {
			context.setProgressStatus(false);
		}
	}, [context, params]);

	// Xử lý tổng tiền PN1 voucher
	useEffect(() => {
		handleSumTotal(dataVoucherPN1);
	}, [dataVoucherPN1]);

	const handleSumTotal = (data) => {
		let sum = 0;
		data.forEach((item) => {
			sum += item.t_tt;
		});
		return formatNumberWithSpaces(sum);
	};

	// delete data PN11 voucher
	const deleteDataVoucherPN1 = useCallback(
		async (id) => {
			core.contextAlert('Bạn có chắc chắn muốn xóa không?', async (isConfirm) => {
				if (!isConfirm) return;

				core.setProgressStatus(true);

				try {
					await core.asyncDeleteList(core.token, api, id);
					await getDataVoucherPN();
				} catch (error) {
					core.contextAlert(error);
				} finally {
					core.setProgressStatus(false);
				}
			});
		},
		[context, getDataVoucherPN]
	);
	const deleteDataVoucherPN1List = useCallback(
		async (ids) => {
			core.contextAlert(`Bạn có chắc chắn muốn xóa ${ids.length} dòng không?`, async (isConfirm) => {
				if (!isConfirm) return;
				core.setProgressStatus(true);
				try {
					const errors = [];
					await Promise.all(
						ids.map((id) => core.asyncDeleteList(core.token, api, id).catch((error) => errors.push(error)))
					);
					if (errors.length) {
						core.contextAlert(
							<>
								<p>{`Có ${errors.length}/${ids.length} dòng không xóa được`}</p>
								{errors.map((e, index) => (
									<div key={index}>{e.error || e}</div>
								))}
							</>
						);
					}
				} catch (error) {
					core.contextAlert(error);
				} finally {
					await getDataVoucherPN();
					core.setProgressStatus(false);
				}
			});
		},
		[context, getDataVoucherPN]
	);

	// handle pagination
	const handlePaginationChange = (page, limit) => {
		setParams({
			...params,
			page,
			limit,
		});
	};

	// on select row click
	const onSelectRowClick = (row) => {
		handleSelectRow(row);
		// console.log("row", row);
	};

	// on row click
	const onRowClick = (row) => {
		getDataVoucherDetail(row);
	};

	// on row double click
	const onRowDoubleClick = (row) => {
		setDataDoubleClick([row]);
	};

	const handleDeleteVoucher = async () => {
		if (dataVoucherSelect.length === 1) {
			await deleteDataVoucherPN1(dataVoucherSelect[0]._id);
		} else if (dataVoucherSelect.length > 1) {
			await deleteDataVoucherPN1List(dataVoucherSelect.map((item) => item._id));
		} else {
			setOpenDelete(true);
		}
		// setDataVoucherSelect([]);
		// setDataVoucherDetail("");
	};

	const handleFilter = (filter) => {
		const newParams = { ...params };

		// Update params
		newParams.page = 1;
		newParams.q = filter;
		setParams(newParams);
	};

	useEffect(() => {
		getDataVoucherPN();
	}, [params.page, params.limit, getDataVoucherPN]);

	return (
		<React.Fragment>
			<VoucherContext.Provider
				value={{
					getDataVoucherPN,
				}}
			>
				<LayoutContainer>
					<div className="box_new_voucher column-start">
						<div className="box_voucher column-start">
							<div className="column-start box_voucher__header">
								<div className="flex-start box_voucher__header__title">
									<div>
										<TfiReload
											size={18}
											color="#206c77"
											style={{
												cursor: 'pointer',
												marginRight: '10px',
												verticalAlign: 'middle',
											}}
											onClick={() => {
												setDataVoucherSelect([]);
												setDataVoucherDetail('');
												setParams({
													...params,
													page: 1,
													limit: 20,
													q: '',
												});
											}}
										/>
									</div>
									<span>Phiếu mua hàng trong nước</span>
								</div>
							</div>
							<div className="column-start box_voucher__body">
								<div className="box_voucher__body__content">
									<TableManager
										idTable={'tableVoucherPN'}
										columns={columns}
										data={dataVoucherPN1}
										updateMyData={updateMyData}
										skipReset={skipResetRef.current}
										settingRow={true}
										selectRow={true}
										onSelectRowClick={onSelectRowClick}
										readonly={true}
										onRowClick={onRowClick}
										onRowDoubleClick={onRowDoubleClick}
										TbodyMaxHeight={'37vh'}
										TbodyMinHeight={'37vh'}
										pagination={true}
										isPage={params.page}
										isLimit={params.limit}
										totalRows={totalRows}
										handlePaginationChange={handlePaginationChange}
										toolBar={
											<div className="flex-start">
												<div>
													<VButton.Filter title="Tìm">
														<VoucherFilter
															onFilter={handleFilter}
															title={'Filter Voucher'}
														/>
													</VButton.Filter>
												</div>
												<div className="flex-start box_voucher__body__header">
													{MenuTabTable.map((item) => {
														const shouldDisplayItem =
															(dataVoucherSelect.length === 1 ||
																(item.id !== 2 && item.id !== 4)) &&
															(dataVoucherSelect.length > 0 || item.id !== 3);

														if (shouldDisplayItem) {
															return (
																<button
																	key={item.id}
																	onClick={item.handle}
																	title={`${item.name}`}
																>
																	{item.icon}{' '}
																	<span className="tabname_tool_bar">
																		{item.name}
																	</span>
																</button>
															);
														}
														return null;
													})}
												</div>
											</div>
										}
									/>
								</div>
							</div>
						</div>
						<div className="box_voucher_detail column-start">
							<VoucherDetail
								data={dataVoucherDetail}
								readonly={true}
								view={true}
								editStatus={true}
								selectRow={false}
								isFieldNt={{
									ma_nt: dataVoucherDetail?.ma_nt,
									ty_gia: dataVoucherDetail?.ty_gia,
								}}
							/>
						</div>
						<div className="total_price_voucher">
							<div>
								<span>Tổng số tiền: </span>
								<span>{handleSumTotal(dataVoucherPN1)}</span>
							</div>
						</div>
						{dataDoubleClick && (
							<EditVoucherDialog
								api={api}
								title={title}
								open={true}
								handleClose={handleCloseEdit}
								data={dataDoubleClick}
								getDataVoucherPN={getDataVoucherPN}
							/>
						)}
						{dataVoucherSelect && dataVoucherSelect.length > 0 ? (
							<>
								<EditVoucherDialog
									api={api}
									title={title}
									open={openEdit}
									handleClose={handleCloseEdit}
									data={dataVoucherSelect}
									getDataVoucherPN={getDataVoucherPN}
								/>
								<CopyVoucherDialog
									api={api}
									title={title}
									open={openCopy}
									handleClose={handleCloseCopy}
									data={handleDataCopyVoucher(dataVoucherSelect)}
									getDataVoucherPN={getDataVoucherPN}
								/>
							</>
						) : (
							<>
								<NotiDialog
									open={openEdit}
									handleClose={handleCloseEdit}
									title="Thông báo"
									content="Vui lòng chọn 1 dòng để thực hiện chức năng này"
								/>
								<NotiDialog
									open={openDelete}
									handleClose={handleCloseDelete}
									title="Thông báo"
									content="Vui lòng chọn ít nhất 1 dòng để thực hiện chức năng này"
								/>
								<NotiDialog
									open={openCopy}
									handleClose={handleCloseCopy}
									title="Thông báo"
									content="Vui lòng chọn ít nhất 1 dòng để thực hiện chức năng này"
								/>
							</>
						)}
						<AddVoucherDialog
							api={api}
							title={title}
							open={openAdd}
							handleClose={handleCloseAdd}
							getDataVoucherPN={getDataVoucherPN}
						/>
					</div>
				</LayoutContainer>
			</VoucherContext.Provider>
		</React.Fragment>
	);
}

export default withContainer(VoucherPN1);
